import { IconIdentifier } from '@boxcryptor-web/icons';
import { ClassName } from '@boxcryptor-web/shared/class-name';
import classnames from 'classnames';
import * as React from 'react';
import { DynamicIcon } from './icons';

const getColors = (variant: InfoBoxVariant) => {
  switch (variant) {
    case 'info':
      return 'bg-blue-100 text-blue-600 prose-info hover:prose-a:text-blue-500';
    case 'warning':
      return 'bg-yellow-100 text-yellow-600 prose-warning hover:prose-a:text-yellow-500';
    case 'danger':
      return 'bg-red-100 text-red-700 prose-danger hover:prose-a:text-red-500';
  }
};

const getProseColors = (variant: InfoBoxVariant) => {
  switch (variant) {
    case 'info':
      return 'prose-info hover:prose-a:text-blue-500';
    case 'warning':
      return 'prose-warning hover:prose-a:text-yellow-500';
    case 'danger':
      return 'prose-danger hover:prose-a:text-red-500';
  }
};

const getIconIdentifier = (variant: InfoBoxVariant): IconIdentifier => {
  switch (variant) {
    case 'info':
      return 'information-circle-solid';
    case 'warning':
      return 'exclamation-circle-solid';
    case 'danger':
      return 'exclamation-triangle-solid';
  }
};

type InfoBoxVariant = 'info' | 'warning' | 'danger';
export const InfoBox: React.FC<ClassName<{ variant: InfoBoxVariant; infoText: React.ReactNode }>> = ({ variant, infoText, className }) => {
  return (
    <div className={classnames('flex items-center px-2.5 py-4 mx-2.5 my-2 gap-4', getColors(variant), className)}>
      <DynamicIcon identifier={getIconIdentifier(variant)} className="flex-shrink-0 flex-grow-0 h-10 w-10" />
      <div className={classnames('prose max-w-full', getProseColors(variant))}>{infoText}</div>
    </div>
  );
};
